import React, { PropTypes } from 'react';
import { Field } from 'redux-form';
import { EmailInputField, TextAreaField } from 'common/components/form_fields';
import AnimatedButton from 'common/components/animated_button';
import ModalDialog from 'common/components/modal/modal_dialog';

const CollaboratorModal = ({
  onSubmit, handleSubmit, isLoading, toggle, showModal,
}) => {
  if (!showModal) {
    return null;
  }

  return (<div>
    <ModalDialog
      dialogClasses="invite-collaborator-modal"
      modalOpen={showModal}
      closeAction={toggle}
      modalHeader="Invite Collaborator"
    >
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Field name="email" component={EmailInputField} label="Email" />
        <Field name="message" component={TextAreaField} label="Message" />
        <div className="modal-actions">
          <AnimatedButton
            processing={isLoading}
            disabled={isLoading}
            type="submit"
            label="Send your message"
          />
          <button className="btn btn-text btn-block" onClick={toggle}>Cancel</button>
        </div>
      </form>
    </ModalDialog>
  </div>);
};

CollaboratorModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  showModal: PropTypes.bool,
};

export default CollaboratorModal;



// WEBPACK FOOTER //
// ./project/components/collaborator_modal.jsx